/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/city.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./city_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CityServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CityServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateCityRequest,
 *   !proto.proto.CreateCityResponse>}
 */
const methodDescriptor_CityService_CreateCity = new grpc.web.MethodDescriptor(
  '/proto.CityService/CreateCity',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateCityRequest,
  proto.proto.CreateCityResponse,
  /**
   * @param {!proto.proto.CreateCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateCityResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateCityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateCityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CityServiceClient.prototype.createCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CityService/CreateCity',
      request,
      metadata || {},
      methodDescriptor_CityService_CreateCity,
      callback);
};


/**
 * @param {!proto.proto.CreateCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateCityResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CityServicePromiseClient.prototype.createCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CityService/CreateCity',
      request,
      metadata || {},
      methodDescriptor_CityService_CreateCity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateCityRequest,
 *   !proto.proto.UpdateCityResponse>}
 */
const methodDescriptor_CityService_UpdateCity = new grpc.web.MethodDescriptor(
  '/proto.CityService/UpdateCity',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateCityRequest,
  proto.proto.UpdateCityResponse,
  /**
   * @param {!proto.proto.UpdateCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateCityResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateCityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateCityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CityServiceClient.prototype.updateCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CityService/UpdateCity',
      request,
      metadata || {},
      methodDescriptor_CityService_UpdateCity,
      callback);
};


/**
 * @param {!proto.proto.UpdateCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateCityResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CityServicePromiseClient.prototype.updateCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CityService/UpdateCity',
      request,
      metadata || {},
      methodDescriptor_CityService_UpdateCity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteCityRequest,
 *   !proto.proto.DeleteCityResponse>}
 */
const methodDescriptor_CityService_DeleteCity = new grpc.web.MethodDescriptor(
  '/proto.CityService/DeleteCity',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteCityRequest,
  proto.proto.DeleteCityResponse,
  /**
   * @param {!proto.proto.DeleteCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteCityResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteCityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteCityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CityServiceClient.prototype.deleteCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CityService/DeleteCity',
      request,
      metadata || {},
      methodDescriptor_CityService_DeleteCity,
      callback);
};


/**
 * @param {!proto.proto.DeleteCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteCityResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CityServicePromiseClient.prototype.deleteCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CityService/DeleteCity',
      request,
      metadata || {},
      methodDescriptor_CityService_DeleteCity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListCityRequest,
 *   !proto.proto.ListCityResponse>}
 */
const methodDescriptor_CityService_ListCity = new grpc.web.MethodDescriptor(
  '/proto.CityService/ListCity',
  grpc.web.MethodType.UNARY,
  proto.proto.ListCityRequest,
  proto.proto.ListCityResponse,
  /**
   * @param {!proto.proto.ListCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListCityResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListCityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListCityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CityServiceClient.prototype.listCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CityService/ListCity',
      request,
      metadata || {},
      methodDescriptor_CityService_ListCity,
      callback);
};


/**
 * @param {!proto.proto.ListCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListCityResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CityServicePromiseClient.prototype.listCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CityService/ListCity',
      request,
      metadata || {},
      methodDescriptor_CityService_ListCity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ItemCityRequest,
 *   !proto.proto.ItemCityResponse>}
 */
const methodDescriptor_CityService_ItemCity = new grpc.web.MethodDescriptor(
  '/proto.CityService/ItemCity',
  grpc.web.MethodType.UNARY,
  proto.proto.ItemCityRequest,
  proto.proto.ItemCityResponse,
  /**
   * @param {!proto.proto.ItemCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ItemCityResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ItemCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ItemCityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ItemCityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CityServiceClient.prototype.itemCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CityService/ItemCity',
      request,
      metadata || {},
      methodDescriptor_CityService_ItemCity,
      callback);
};


/**
 * @param {!proto.proto.ItemCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ItemCityResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CityServicePromiseClient.prototype.itemCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CityService/ItemCity',
      request,
      metadata || {},
      methodDescriptor_CityService_ItemCity);
};


module.exports = proto.proto;

